import { useState, useEffect } from 'react';
import AddNewGuarantor from './AddNewGuarantor';
import { useSelector } from 'react-redux';
import { enumUtil } from '../../../../utils/Enum';
import { GetZipCode, ServerRequestProtected } from '../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../utils/NotificationHandler';
import Loader from '../../../shared/Loader/Loader';
import FormValidator from '../../../../utils/FormValidator';
import isNull from '../../../../utils/NullChecking';
import States, { Relation, Gender } from '../../../../utils/Constants';
import DatePicker from '../../../General/DatePicker';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import handleNumericCheck from '../../../../utils/HandleNumericKeys';
import FormatPhoneNumber from '../../../../utils/FormatPhoneNumber';
import ReactInputMask from 'react-input-mask';
import { FindFirstChild } from '../../../../utils/FindMenuOption';
import { useKeyboardShortcut } from '../../../../utils/useKeyboardShortcut';
const Guarantor = (props) => {
    let IsEditAllowed = FindFirstChild('Patient', 'Gurantor').IsAdd
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    PateintIDR = PateintIDR?.data?.id
    const [PatientID, setPatientID] = useState()
    let Guarantor_Modal = {
        PatientGuarantorID: "",
        ParentID: "",
        LastName: "",
        FirstName: "",
        MI: "",
        Gender: "",
        Relation: "",
        GuarantorAddress: "",
        GuarantorCity: "",
        GuarantorState: "",
        GuarantorZip: "",
        GuarantorNotes: "",
        GuarantorMobile: "",
        GuarantorHomePhone: "",
    }
    let EmergenctContact_Modal = {
        PatientEmergencyContactID: "",
        Name: "",
        Email: "",
        DOB: null,
        EmergencyAddress: "",
        EmergencyCity: "",
        EmergencyState: "",
        EmergencyZip: "",
        EmergencyNotes: "",
        EmergencyMobile: "",
        EmergencyHomePhone: "",
        ParentID: "",
    }
    let Family_Modal = {
        ParentID: "",
        Name: "",
        DOB: "",
        MobileNumber: "",
        Address: "",
        City: "",
        State: "",
        ZipCode: "",
        DeathDate: "",
        Notes: "",
    }
    let valModal = {}
    let ValidationModal = {
        LastNameVal: "",
        FirstNameVal: "",
        NameVal: "",
        ZipCodeEmergLengthVal: "",
        ZipCodeContLengthVal: "",
        MIval: "",
        ZipCodeContDigitVal: "",
        EmergenctContactLegthVal: "",
        GuarantorContactLegthVal: "",
        EmergencyHomePhoneVal: "",
        GuarantorHomePhoneVal: ""

    }
    const API_URL = enumUtil.controller.PATIENT
    const [isOpenGuarantor, setisOpenGuarantor] = useState(false);
    const [mainGuarantorModal, setmainGuarantorModal] = useState(Guarantor_Modal);
    const [GuarantorSaveUpdateModal, setGuarantorSaveUpdateModal] = useState({})
    const [GuarantorValidationModal, setGuarantorValidationModal] = useState(ValidationModal)
    const [PatientGuarantorID, setPatientGuarantorID] = useState();
    const [GuarantorID, setGuarantorID] = useState('0');
    //EmergencyContact
    const [mainEmergencyContactModal, setmainEmergencyContactModal] = useState(EmergenctContact_Modal);
    const [EmergencyContactSaveUpdateModal, setEmergencyContactSaveUpdateModal] = useState({})
    const [EmergencyContactValidationModal, setEmergencyContactValidationModal] = useState(ValidationModal)
    const [PatientEmergencyContactID, setPatientEmergencyContactID] = useState();
    const [EmergencyContactID, setEmergencyContactID] = useState();
    const [isLoading, setIsLoading] = useState(false)
    const [mainFamilyModal, setmainFamilyModal] = useState([Family_Modal]);
    const [isClose, setIsClose] = useState();
    const [DOB, setDOB] = useState(null)
    const openDOB = Boolean(DOB)
    const [dateOfDeath, setDateOfDeath] = useState(null)
    const openDateOfDeath = Boolean(dateOfDeath)
    const [is, setIs] = useState(false);
    const [FamilyMemberID, setFamilyMemberID] = useState('0')
    const handleGuarantorClose = () => {
        setisOpenGuarantor(false);
        setIsClose((Math.random()));
    }
    const handleGuarantorShow = () => {
        setisOpenGuarantor(true);
        setFamilyMemberID('0')
    }

    const LoadGurantorData = () => {
        if (PateintIDR != -1) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindPatientChildRecords ", 'post', {
                "ParentID": PateintIDR,
                "TableName": enumUtil.enumAPITableName.PatientGuarantor
            }).then((response) => {
                setIsLoading(false)
                setIs(true)

                // if (!isNull(response.EmergencyMobile)) {
                //     response.EmergencyMobile = FormatPhoneNumber(response.EmergencyMobile)
                // }
                if (response.patientGuarantor.length === 0) {
                    setGuarantorID(0)
                } else {
                    States.filter((type) => {
                        if (type.value === response.patientGuarantor[0].GuarantorState) {
                            response.patientGuarantor[0].GuarantorState = type.display
                        }
                    })
                    Gender.filter((type) => {
                        if (type.value === response.patientGuarantor[0].Gender) {
                            response.patientGuarantor[0].Gender = type.display
                        }
                    })
                    setGuarantorID(response.patientGuarantor[0].PatientGuarantorID)
                    setmainGuarantorModal(response.patientGuarantor[0])
                }
                if (response.PatientEmergencyCOntact.length === 0) {
                    setEmergencyContactID(0)
                } else {
                    States.filter((type) => {
                        if (type.value === response.PatientEmergencyCOntact[0].EmergencyState) {
                            response.PatientEmergencyCOntact[0].EmergencyState = type.display
                        }
                    })
                    if (!isNull(response.PatientEmergencyCOntact[0].EmergencyMobile)) {
                        response.PatientEmergencyCOntact[0].EmergencyMobile = FormatPhoneNumber(response.PatientEmergencyCOntact[0].EmergencyMobile)
                    }
                    setEmergencyContactID(response.PatientEmergencyCOntact[0].PatientEmergencyContactID)
                    setmainEmergencyContactModal(response.PatientEmergencyCOntact[0])
                }
                setmainFamilyModal(response.PatientFamilyMember)

            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                setIsLoading(false)
            })
        } else {
            setIsLoading(false)
            NotificationHandler('Please Fill Demographics First', enumUtil.enumtoaster.warning);
        }
    }
    useEffect(() => {
        LoadGurantorData()
    }, [isClose])
    useEffect(() => {
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 215) {
                    LoadGurantorData()

                }
            })
        }
    }, [props.Reload])
    useEffect(() => {
        if (PateintIDR) {
            setPatientID(PateintIDR)
        }
    }, [])
    const handleGuarantorChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainGuarantorModal };
        let saveModal = { ...GuarantorSaveUpdateModal }
        if (name === 'GuarantorMobile') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        }
        else if (name === 'GuarantorZip') {
            GetZipCode(value)
                .then(data => {
                    modal.GuarantorState = data.main.State
                    modal.GuarantorCity = data.main.City
                    setmainGuarantorModal(prevState => ({ ...prevState, ...data?.main }));
                    saveModal.GuarantorState = data.save.State
                    saveModal.GuarantorCity = data.save.City
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else {
            modal[name] = value;
        }
        setmainGuarantorModal(modal)
        for (var property in Guarantor_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setGuarantorSaveUpdateModal(saveModal)
    }
    const handleEmergencyContactChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainEmergencyContactModal };
        let saveModal = { ...EmergencyContactSaveUpdateModal }
        if (name === 'EmergencyMobile') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        }
        else if (name === 'EmergencyZip') {
            GetZipCode(value)
                .then(data => {
                    modal.EmergencyState = data.main.State
                    modal.EmergencyCity = data.main.City
                    setmainEmergencyContactModal(prevState => ({ ...prevState, ...data?.main }));
                    saveModal.EmergencyState = data.save.State
                    saveModal.EmergencyCity = data.save.City
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else {
            modal[name] = value;
        }
        setmainEmergencyContactModal(modal)
        for (var property in EmergenctContact_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setEmergencyContactSaveUpdateModal(saveModal)
    }
    const GuarantorValidation = async () => {
        let PhoneNumber = '';
        if (!isNull(mainEmergencyContactModal.EmergencyMobile)) {
            PhoneNumber = mainEmergencyContactModal.EmergencyMobile.replace(/[()-\s]/g, '');
        }
        let GuranterPhoneNumber = '';
        if (!isNull(mainGuarantorModal.GuarantorMobile)) {
            GuranterPhoneNumber = mainGuarantorModal.GuarantorMobile.replace(/[()-\s]/g, '');
        }
        let HomePhoneNumber = '';
        if (!isNull(mainEmergencyContactModal.EmergencyHomePhone)) {
            HomePhoneNumber = mainEmergencyContactModal.EmergencyHomePhone.replace(/-/g, "");
        }
        let GuarantorHomePhoneNumber = '';
        if (!isNull(mainGuarantorModal.GuarantorHomePhone)) {
            GuarantorHomePhoneNumber = mainGuarantorModal.GuarantorHomePhone.replace(/[()-\s]/g, '');
        }

        let ValidationModal = {
            LastNameVal: FormValidator(
                mainGuarantorModal.LastName,
                enumUtil.enumValidationType.Required,
                'Last Name',
            ),
            FirstNameVal: FormValidator(
                mainGuarantorModal.FirstName,
                enumUtil.enumValidationType.Required,
                'First Name',
            ),
            NameVal: FormValidator(
                mainEmergencyContactModal.Name,
                enumUtil.enumValidationType.Required,
                'Name',
            ),
            ZipCodeContLengthVal: FormValidator(
                mainGuarantorModal.GuarantorZip,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            ZipCodeContDigitVal: FormValidator(
                mainGuarantorModal.GuarantorZip,
                enumUtil.enumValidationType.Digit,
                'Zip Code'
            ),
            ZipCodeEmergLengthVal: FormValidator(
                mainEmergencyContactModal.EmergencyZip,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            MIval: FormValidator(
                mainGuarantorModal.MI,
                enumUtil.enumValidationType.Alphabet,
                'MI'
            ),
            EmergenctContactLegthVal: FormValidator(
                PhoneNumber,
                enumUtil.enumValidationType.Length,
                'Mobile Number',
                10
            ),
            EmergencyHomePhoneVal: FormValidator(
                HomePhoneNumber,
                enumUtil.enumValidationType.Length,
                'Home Number',
                10
            ),
            GuarantorContactLegthVal: FormValidator(
                GuranterPhoneNumber,
                enumUtil.enumValidationType.Length,
                'Mobile Number',
                10
            ),
            GuarantorHomePhoneVal: FormValidator(
                GuarantorHomePhoneNumber,
                enumUtil.enumValidationType.Length,
                'Home Number',
                10
            ),

        }
        await setGuarantorValidationModal(ValidationModal)
        await setEmergencyContactValidationModal(ValidationModal)

        valModal = ValidationModal
    }
    const handleSave = async () => {
        await GuarantorValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            GuarantorSaveUpdateModal['ParentID'] = PateintIDR + "";
            setGuarantorSaveUpdateModal(GuarantorSaveUpdateModal)
            EmergencyContactSaveUpdateModal['ParentID'] = PateintIDR + "";
            if (!isNull(EmergencyContactSaveUpdateModal.EmergencyMobile)) {
                EmergencyContactSaveUpdateModal['EmergencyMobile'] = EmergencyContactSaveUpdateModal.EmergencyMobile.replace(/[()-\s]/g, "");
            }
            if (!isNull(GuarantorSaveUpdateModal.GuarantorMobile)) {
                GuarantorSaveUpdateModal['GuarantorMobile'] = GuarantorSaveUpdateModal.GuarantorMobile.replace(/[()-\s]/g, "");
            }
            if (!isNull(EmergencyContactSaveUpdateModal.EmergencyHomePhone)) {
                EmergencyContactSaveUpdateModal['EmergencyHomePhone'] = EmergencyContactSaveUpdateModal.EmergencyHomePhone.replace(/-/g, "");
            }
            if (!isNull(GuarantorSaveUpdateModal.GuarantorHomePhone)) {
                GuarantorSaveUpdateModal['GuarantorHomePhone'] = GuarantorSaveUpdateModal.GuarantorHomePhone.replace(/[()-\s]/g, "");
            }
            setEmergencyContactSaveUpdateModal(EmergencyContactSaveUpdateModal)
            setGuarantorSaveUpdateModal(EmergencyContactSaveUpdateModal)
            let Guarantor = {
                TableName: enumUtil.enumAPITableName.PatientGuarantor,
                ID: GuarantorID + "", // 0 in new case and in update case use value from reduc(Insurrance list component)
                data: { ...GuarantorSaveUpdateModal },
                value: null
            }
            let EmergenctContact = {
                TableName: enumUtil.enumAPITableName.PatientEmergencyContact,
                ID: EmergencyContactID + "", // 0 in new case and in update case use value from reduc(Insurrance list component)
                data: { ...EmergencyContactSaveUpdateModal },
                value: null
            }
            let saveModal = {
                TablesData: [
                    Guarantor,
                    EmergenctContact
                ]
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveMultipleRecords", 'post', saveModal).then((response) => {
                if (!isNull(response[0].ID)) {
                    setIsLoading(false)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    // setPracticeID(response.id)
                    setGuarantorID(response[0].ID)
                    if (response[1].ID !== null) { setEmergencyContactID(response[1].ID) }
                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.message, enumUtil.enumtoaster.error)
            })
        }
    }
    const onDeleteFamilyMember = () => {
        setisOpenGuarantor(false)
        setIsClose((Math.random()))
    }
    let PopupScreen = '';
    if (isOpenGuarantor) {
        PopupScreen = <AddNewGuarantor isOpenGuarantor={isOpenGuarantor} OnClose={handleGuarantorClose} onDeleteFamilyMember={onDeleteFamilyMember} FamilyMemberID={FamilyMemberID} />
    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainEmergencyContactModal };
        let saveModal = { ...EmergencyContactSaveUpdateModal }
        modal[type] = FormatedDate
        setmainEmergencyContactModal(modal)
        for (var property in EmergenctContact_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setEmergencyContactSaveUpdateModal(saveModal)
    }
    const handleDropDownChangeEmerg = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainEmergencyContactModal };
        modal[name] = value

        setmainEmergencyContactModal(modal)
    }
    const handleSelectedDataEmer = (selectedData, name, type) => {
        let modal = { ...mainEmergencyContactModal };
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            EmergencyContactSaveUpdateModal[name] = selectedData.value;
        } else if (type === 'server' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            EmergencyContactSaveUpdateModal[name] = selectedData.value;
        } else {
            modal[name] = ''
            EmergencyContactSaveUpdateModal[name] = ''
        }
        setmainEmergencyContactModal(modal)

        return selectedData
    }
    const handleDropDownChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainGuarantorModal };
        modal[name] = value
        setmainGuarantorModal(modal)
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainGuarantorModal };
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            GuarantorSaveUpdateModal[name] = selectedData.value;
        } else if (type === 'server' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            GuarantorSaveUpdateModal[name] = selectedData.value;
        } else {
            modal[name] = ''
            GuarantorSaveUpdateModal[name] = ''
        }
        setmainGuarantorModal(modal)

        return selectedData
    }
    const AddFamilyMember = (id) => {
        setisOpenGuarantor(true)
        setFamilyMemberID(id)
    }
    const isOnPatientSubTab215 = DropDowns?.PatientSubActiveTab === 215;
    const enabled =
        isOnPatientSubTab215 &&
        props.ActivePatientID === PatientID;
    useKeyboardShortcut("s+c", handleSave, 300, enabled);
    return (
        <>
            {PopupScreen}
            {isLoading ? <Loader /> : null}
            <div className='tabs-container'>
                <div className="row demograpics_screen_size m-0">
                    <div className="col-md-3">
                        <div className="p-2 px-0">
                            <p className="heading">Guarantor</p>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group input mb-1">
                                        <label>Relation</label>
                                        {/* <select
                                            className='form-control'
                                            id='Relation'
                                            name='Relation'
                                            onChange={handleGuarantorChange}
                                        >
                                            {Relation.map((e, indexmainGuarantorModal) => (
                                                <option value={e.value} key={index}>
                                                    {e.value}
                                                </option>
                                            ))}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='Relation'
                                            name='Relation'
                                            searchValue={mainGuarantorModal.Relation}
                                            data={Relation}
                                            onChange={handleDropDownChange}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className='input'>
                                        <label>Last Name<span className='req'>*</span></label>
                                        <div className={GuarantorValidationModal.LastNameVal ? 'form-group input mb-1 error' : 'form-group input mb-1'}>
                                            <input type="text"
                                                className="form-control"
                                                name="LastName"
                                                id="LastName"
                                                autoComplete='off'
                                                value={mainGuarantorModal.LastName}
                                                onChange={handleGuarantorChange}
                                            />
                                            {GuarantorValidationModal.LastNameVal}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className='input'>
                                        <label>First Name<span className='req'>*</span></label>
                                        <div className={GuarantorValidationModal.FirstNameVal ? 'form-group input mb-1 error' : 'form-group input mb-1'}>
                                            <input type="text"
                                                className="form-control"
                                                name="FirstName"
                                                id="FirstName"
                                                autoComplete='off'
                                                value={mainGuarantorModal.FirstName}
                                                onChange={handleGuarantorChange}
                                            />
                                            {GuarantorValidationModal.FirstNameVal}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group input mb-1">
                                        <label>MI</label>
                                        <div className={GuarantorValidationModal.MIval ? 'form-group input mb-1 error' : 'form-group input mb-1'}>
                                            <input type="text"
                                                className="form-control"
                                                name="MI"
                                                id="MI"
                                                autoComplete='off'
                                                maxLength={3}
                                                value={mainGuarantorModal.MI}
                                                onChange={handleGuarantorChange}
                                            />
                                            {GuarantorValidationModal.MIval}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group input mb-1">
                                        <label>Sex</label>
                                        <SuperSearchList
                                            type="client"
                                            id='Gender'
                                            name='Gender'
                                            searchValue={mainGuarantorModal.Gender}
                                            data={Gender}
                                            onChange={handleGuarantorChange}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group input mb-1">
                                        <label>Address</label>
                                        <input type="text"
                                            className="form-control"
                                            name="GuarantorAddress"
                                            id="GuarantorAddress"
                                            autoComplete='off'
                                            value={mainGuarantorModal.GuarantorAddress}
                                            onChange={handleGuarantorChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group input mb-1">
                                        <label>City</label>
                                        <input type="text"
                                            className="form-control"
                                            name="GuarantorCity"
                                            id="GuarantorCity"
                                            autoComplete='off'
                                            value={mainGuarantorModal.GuarantorCity}
                                            onChange={handleGuarantorChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group input mb-1">
                                        <label>State</label>
                                        <SuperSearchList
                                            type="client"
                                            id='GuarantorState'
                                            name='GuarantorState'
                                            searchValue={mainGuarantorModal.GuarantorState}
                                            data={States}
                                            onChange={handleDropDownChange}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                        {/* <input type="text"
                                            className="form-control"
                                            name="GuarantorState"
                                            id="GuarantorState"
                                            maxLength={2}
                                            value={mainGuarantorModal.GuarantorState}
                                            onChange={handleGuarantorChange}
                                        /> */}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className='input'>
                                        <label>Zip</label>
                                        <div className={GuarantorValidationModal.ZipCodeContLengthVal || GuarantorValidationModal.ZipCodeContDigitVal ? 'form-group input mb-1 error' : 'form-group input mb-1'}>
                                            <input type="text"
                                                className="form-control"
                                                name="GuarantorZip"
                                                id="GuarantorZip"
                                                autoComplete='off'
                                                maxLength={9}
                                                onKeyPress={handleNumericCheck}
                                                value={mainGuarantorModal.GuarantorZip}
                                                onChange={handleGuarantorChange}
                                            />
                                            {GuarantorValidationModal.ZipCodeContLengthVal || GuarantorValidationModal.ZipCodeContDigitVal}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className='input'>
                                        <label>Cell #</label>
                                        <div className={GuarantorValidationModal.GuarantorContactLegthVal ? 'form-group input mb-1 error' : 'form-group input mb-1'}>
                                            <input type="text"
                                                className="form-control"
                                                name="GuarantorMobile"
                                                id="GuarantorMobile"
                                                autoComplete='off'
                                                placeholder="(555) 555-5555"
                                                onKeyPress={handleNumericCheck}
                                                value={mainGuarantorModal.GuarantorMobile}
                                                onChange={handleGuarantorChange}
                                            />
                                            {GuarantorValidationModal.GuarantorContactLegthVal}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className='input'>
                                        <label>Home #</label>
                                        <div className={GuarantorValidationModal.GuarantorHomePhoneVal ? 'form-group input mb-1 error' : 'form-group input mb-1'}>
                                            <ReactInputMask type="text"
                                                className="form-control"
                                                name="GuarantorHomePhone"
                                                id="GuarantorHomePhone"
                                                autoComplete='off'
                                                maskChar={0}
                                                mask='999-999-9999'
                                                onKeyPress={handleNumericCheck}
                                                value={mainGuarantorModal.GuarantorHomePhone}
                                                onChange={handleGuarantorChange}
                                            />
                                            {GuarantorValidationModal.GuarantorHomePhoneVal}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group input mb-1">
                                        <label>Notes</label>
                                        <textarea
                                            className="form-control"
                                            name="GuarantorNotes"
                                            id="GuarantorNotes"
                                            value={mainGuarantorModal.GuarantorNotes}
                                            onChange={handleGuarantorChange}
                                            rows='3'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 br-clr br-right-1 br-left-1">
                        <div className="p-2 px-0">
                            <p className="heading">Emergency Contact</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className='input'>
                                        <label>Name<span className='req'>*</span></label>
                                        <div className={EmergencyContactValidationModal.NameVal ? 'form-group input mb-1 error' : 'form-group input mb-1'}>
                                            <input type="text"
                                                className="form-control"
                                                name="Name"
                                                id="Name"
                                                autoComplete='off'
                                                value={mainEmergencyContactModal.Name}
                                                onChange={handleEmergencyContactChange}
                                            />
                                            {EmergencyContactValidationModal.NameVal}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <DatePicker
                                        label='DOB'
                                        value={!isNull(mainEmergencyContactModal.DOB) ? mainEmergencyContactModal.DOB : null}
                                        maxDate={new Date()}
                                        handleCalendarChangefunc={(e) => handleCalendarChange(e, 'DOB')}
                                    />
                                    {/* <CalendarInput
                                        label='DOB'
                                        value={mainEmergencyContactModal.DOB}
                                        openCalendarMenufunc={(event) => openCalendarMenu(event, 'DOB')}
                                        anchorEl={DOB}
                                        open={openDOB}
                                        closeCalendarMenufunc={closeCalendarMenu}
                                        handleCalendarChangefunc={date => handleCalendarChange(date, 'DOB')}
                                    /> */}
                                </div>
                                <div className="col-md-6">
                                    <div className={EmergencyContactValidationModal.EmergenctContactLegthVal ? 'input error' : 'form-group input mb-1'}>
                                        <label>Cell #</label>
                                        <input type="text"
                                            className="form-control"
                                            name="EmergencyMobile"
                                            id="EmergencyMobile"
                                            placeholder="(555) 555-5555"
                                            autoComplete='off'
                                            onKeyPress={handleNumericCheck}
                                            value={mainEmergencyContactModal.EmergencyMobile}
                                            onChange={handleEmergencyContactChange}
                                        />
                                        {EmergencyContactValidationModal.EmergenctContactLegthVal}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input">
                                        <label>Home #</label>
                                        <div className={EmergencyContactValidationModal.EmergencyHomePhoneVal ? 'form-group input mb-1 error' : 'form-group input mb-1'}>
                                            <ReactInputMask type="text"
                                                className="form-control"
                                                name="EmergencyHomePhone"
                                                id="EmergencyHomePhone"
                                                maskChar={0}
                                                autoComplete='off'
                                                mask='999-999-9999'
                                                onKeyPress={handleNumericCheck}
                                                value={mainEmergencyContactModal.EmergencyHomePhone}
                                                onChange={handleEmergencyContactChange}
                                            />
                                            {EmergencyContactValidationModal.EmergencyHomePhoneVal}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group input mb-1">
                                        <label>Email</label>
                                        <input type="text"
                                            className="form-control"
                                            name="Email"
                                            id="Email"
                                            autoComplete='off'
                                            maxLength={50}
                                            value={mainEmergencyContactModal.Email}
                                            onChange={handleEmergencyContactChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group input mb-1">
                                        <label>Address</label>
                                        <input type="text"
                                            className="form-control"
                                            name="EmergencyAddress"
                                            id="EmergencyAddress"
                                            autoComplete='off'
                                            maxLength={35}
                                            value={mainEmergencyContactModal.EmergencyAddress}
                                            onChange={handleEmergencyContactChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group input mb-1">
                                        <label>City</label>
                                        <input type="text"
                                            className="form-control"
                                            name="EmergencyCity"
                                            id="EmergencyCity"
                                            autoComplete='off'
                                            maxLength={30}
                                            value={mainEmergencyContactModal.EmergencyCity}
                                            onChange={handleEmergencyContactChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input">
                                        <label>State</label>
                                        <SuperSearchList
                                            type="client"
                                            id='EmergencyState'
                                            name='EmergencyState'
                                            searchValue={mainEmergencyContactModal.EmergencyState}
                                            data={States}
                                            onChange={handleDropDownChangeEmerg}
                                            getSelectedData={handleSelectedDataEmer}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                        {/* <input type="text"
                                     className="form-control"
                                     name="EmergencyState"
                                     id="EmergencyCity"
                                     maxLength={2}
                                     value={mainEmergencyContactModal.EmergencyState}
                                     onChange={handleEmergencyContactChange} 
                                     /> */}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={GuarantorValidationModal.ZipCodeEmergLengthVal ? 'form-group input mb-1 error' : 'form-group input mb-1'}>
                                        <label>Zip</label>
                                        <input type="text"
                                            className="form-control"
                                            name="EmergencyZip"
                                            id="EmergencyZip"
                                            maxLength={9}
                                            autoComplete='off'
                                            onKeyPress={handleNumericCheck}
                                            value={mainEmergencyContactModal.EmergencyZip}
                                            onChange={handleEmergencyContactChange}
                                        />
                                        {GuarantorValidationModal.ZipCodeEmergLengthVal}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group input mb-1">
                                        <label> Lives with Patient </label>
                                        <input type="text"
                                            className="form-control"
                                            name="EmergencyCity"
                                            id="EmergencyCity"
                                            autoComplete='off'
                                            maxLength={30}
                                            value={mainEmergencyContactModal.EmergencyCity}
                                            onChange={handleEmergencyContactChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group input mb-1">
                                        <label>Have Keys</label>
                                        <input type="text"
                                            className="form-control"
                                            id='HaveKeys'
                                            name='HaveKeys'
                                            autoComplete='off'
                                            maxLength={30}
                                            value={mainEmergencyContactModal.EmergencyCity}
                                            onChange={handleEmergencyContactChange}
                                        />
                                        {/* <input type="text"
                                     className="form-control"
                                     name="EmergencyState"
                                     id="EmergencyCity"
                                     maxLength={2}
                                     value={mainEmergencyContactModal.EmergencyState}
                                     onChange={handleEmergencyContactChange} 
                                     /> */}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group input mb-1">
                                        <label>Notes</label>
                                        <textarea
                                            className="form-control"
                                            name="EmergencyNotes"
                                            id="EmergencyNotes"
                                            autoComplete='off'
                                            value={mainEmergencyContactModal.EmergencyNotes}
                                            onChange={handleEmergencyContactChange}
                                            rows='3'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="p-2 px-0">
                            <div className="d-flex justify-content-between mb-3">
                                <p className="heading">Family Members</p>
                                <button onClick={handleGuarantorShow} className="btn btn-theme btn-xs no-width d-flex align-items-center">
                                    <div class="alert-icon session-btn app_tooltip bottom"><i class="fs-11 h-100 icon-plus-icon me-2 opacity-100 p-2px w-100"></i></div>
                                    Add New Family Members</button>
                            </div>
                            <div className="row row-gap-15">
                                {mainFamilyModal.length > 0 ?
                                    mainFamilyModal.map((item) => {
                                        return (
                                            <div className="col-md-6">
                                                <div className="card card-light-green">
                                                    <div className="br-light br-bottom-1 pb-2 mb-2">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className='d-flex align-items-center gap-1'>
                                                                <i className="icon-user-solid-circle ar-dark-color fs-14"></i>
                                                                <p className="heading fs-13">{item.Name}</p>
                                                            </div>
                                                            <p className="text fs-12 ar-light-color font-m">{item.DOB} <span>(33)</span></p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className='d-flex align-items-center gap-1'>
                                                            <i className="icon-phone fs-13 ar-dark-color"></i>
                                                            {item.MobileNumber ? (
                                                                <p className="text fs-11">{item.MobileNumber}</p>
                                                            ) : (
                                                                <p className="text fs-11 za-blue-clr text-decoration-underline">Add Phone Number</p>
                                                            )
                                                            }
                                                        </div>
                                                        <div className='d-flex align-items-center gap-1'>
                                                            <i className="icon-Icon-material-location-on fs-13"></i>
                                                            {item.Address ? (
                                                                <p className="text fs-11">{item.Address}</p>
                                                            ) : (
                                                                <p className="text fs-11 za-blue-clr text-decoration-underline">Add Address</p>
                                                            )
                                                            }
                                                        </div>
                                                        <div className='d-flex justify-content-between align-items-center'>
                                                            {item.ZipCode ? (
                                                                <p className="text fs-11 "><span className='font-sb'>Zip Code : </span>{item.ZipCode}</p>
                                                            ) : (
                                                                <p className="text fs-11 "><span className='font-sb'>Zip Code : </span>N/A</p>
                                                            )}
                                                            {item.DeathDate ? (
                                                                <p className="text fs-11"><span className='font-sb'> DOD : </span>{item.DeathDate}</p>
                                                            ) : (
                                                                <p className="text fs-11"><span className='font-sb'> DOD : </span>N/A</p>
                                                            )}
                                                        </div>
                                                        {item.Notes ? (
                                                            <p className="text mb-10">
                                                                <span className="font-sb">Notes</span><br />
                                                                {item.Notes}
                                                            </p>
                                                        ) :
                                                            (
                                                                <p className="text mb-10">
                                                                    <span className="font-sb">Notes</span><br /> <span className='za-blue-clr text-decoration-underline'>Add Notes</span></p>
                                                            )}
                                                    </div>
                                                    <button className='btn-blue-light btn heading' onClick={() => AddFamilyMember(item.PatientFamilyMemberID)}>Edit</button>
                                                </div>
                                            </div>
                                        )
                                    }) : null}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='tabs-action-bottom br-top-1 br-bottom-1 br-clr justify-content-between d-flex py-2 position-static'>
                    <div className='col-md-3'>
                        <div className='ms-3 py-1'>
                            <p className='heading heading_ext d-flex align-items-center gap-01'>Updated By/Date: <span className='text text_color'>{!isNull(mainGuarantorModal.UpdatedBy) ? mainGuarantorModal.UpdatedBy+ ', ' + mainGuarantorModal.UpdatedDate  : 'N/A'}</span></p>
                        </div>
                    </div>
                    <div className='btns-group text-end px-3 d-flex align-items-center justify-content-end py-2'>
                        <button className='btn btn-gray mt-1 me-2'>Cancel</button>
                        <button className={IsEditAllowed ? 'btn btn-orange mt-1' : 'btn btn-orange mt-1 disabled'} onClick={handleSave}>Save</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Guarantor